import { ajax } from "@utils";

export const delegatePackageService = {
  /**
   * 取得貨運包裹列表
   * @key SearchConstructionDelegatePackageByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getAll: (constructionUuid, condition) => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/delegate-packages`,
        {
          params: {
            ...condition
          }
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.data;
      });
  },
  /**
   * 刪除寄物包裹
   * @key DeleteConstructionDelegatePackageByProperty
   * @param {number} id - 包裹 id
   * @returns
   */
  delete: id => {
    return ajax
      .delete(`${process.env.REACT_APP_API_URL}/property/construction-delegate-packages/${id}`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 領取寄物包裹
   * @key ChangeConstructionDelegatePackageToCollectedByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 包裹資訊
   * @returns
   */
  collect: (constructionUuid, info) => {
    return ajax
      .put(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/delegate-packages/collected`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res;
      });
  },
  /**
   * 取得寄物包裹資訊
   * @key GetConstructionDelegatePackageByProperty
   * @param {number} id - 貨運包裹 id
   * @returns
   */
  get: id => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/construction-delegate-packages/${id}`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 更新寄物包裹資訊
   * @key UpdateConstructionDelegatePackageByProperty
   * @param {number} id - 寄物包裹 id
   * @param {object} info - 寄物包裹資訊
   * @returns
   */
  update: (id, info) => {
    return ajax
      .put(`${process.env.REACT_APP_API_URL}/property/construction-delegate-packages/${id}`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...info
        })
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res;
      });
  },
  /**
   * 新增寄物包裹資訊
   * @key CreateConstructionDelegatePackageByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 包裹資訊
   *
   * @returns
   */
  create: (constructionUuid, info) => {
    return ajax
      .post(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/delegate-packages`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res;
      });
  }
};
